import React from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import styles from './componentStyles'; // Import the styles object

const DraggableList = ({ project, setWinnerItems, toggleComponent, items, setItems, setLoading }) => {
  const { scores, question } = project || {};

  const handleOnDragEnd = (result) => {
    if (!result.destination) return;

    const reorderedItems = Array.from(items);
    const [reorderedItem] = reorderedItems.splice(result.source.index, 1);
    reorderedItems.splice(result.destination.index, 0, reorderedItem);

    setItems(reorderedItems);
  };

  const goToNextPage = async () => {
    setLoading(true);
    for (let index = 0; index < items.length; index++) {
      const element = items[index];
      element.totalPoints = (element.data1 + scores[`score${index + 1}`]) || 0;
    }

    const filterElements = items.slice().sort((a, b) => b.totalPoints - a.totalPoints);
    setWinnerItems(filterElements);

    setTimeout(() => {
      setLoading(false);
      toggleComponent();
    }, 2000)

  };

  return (
    <DragDropContext onDragEnd={handleOnDragEnd}>
      <header style={styles.appHeader()}>
        <h1 style={styles.headerTitle(project)}>{question}</h1>
      </header>
      <Droppable droppableId="items">
        {(provided) => (
          <div {...provided.droppableProps} ref={provided.innerRef} style={styles.listContainer()}>
            {items && items.map((item, index) => (
              <Draggable key={item.id} draggableId={item.id ? item.id.toString() : index.toString()} index={index}>
                {(provided, snapshot) => (
                  <div
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                    style={{
                      ...provided.draggableProps.style,
                      padding: '8px',
                      margin: '4px 0',
                      backgroundColor: snapshot.isDragging ? '#263B4A' : '#456C86',
                      color: 'white',
                      borderRadius: '4px',
                      boxShadow: snapshot.isDragging ? '0 2px 10px rgba(0,0,0,0.2)' : 'none',
                      transition: 'all 0.2s ease',
                    }}
                  >
                    <div style={styles.listItemContainer()}>
                      <div style={styles.listItemId(project)}>{index + 1}</div>
                      <div>{item.label}</div>
                      <div style={styles.listItemId(project)}></div>
                    </div>
                  </div>
                )}
              </Draggable>
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
      <div style={styles.submitButtonContainer()}>
        <div style={styles.submitButton(project)} onClick={goToNextPage}>
          Continue
        </div>
      </div>
    </DragDropContext>
  );
};

export default DraggableList;
